export var FileFormat;
(function (FileFormat) {
    FileFormat["JPG"] = "jpg";
    FileFormat["JPEG"] = "jpeg";
    FileFormat["PNG"] = "png";
    FileFormat["GIF"] = "gif";
    FileFormat["ICO"] = "ico";
    FileFormat["SVG"] = "svg";
    FileFormat["MP3"] = "mp3";
    FileFormat["MP4"] = "mp4";
    FileFormat["MOV"] = "mov";
    FileFormat["WAV"] = "wav";
    FileFormat["CSV"] = "csv";
    FileFormat["PDF"] = "pdf";
    FileFormat["TXT"] = "txt";
    FileFormat["XML"] = "xml";
    FileFormat["XLS"] = "xls";
    FileFormat["XLSX"] = "xlsx";
    FileFormat["DOC"] = "doc";
    FileFormat["XDOC"] = "xdoc";
})(FileFormat || (FileFormat = {}));
export var Byte;
(function (Byte) {
    Byte[Byte["KILO"] = 1024] = "KILO";
    Byte[Byte["MEGA"] = 1048576] = "MEGA";
    Byte[Byte["GIGA"] = 1073741824] = "GIGA";
    Byte[Byte["TERA"] = 1099511627776] = "TERA";
    Byte[Byte["PETA"] = 1125899906842624] = "PETA";
})(Byte || (Byte = {}));
//# sourceMappingURL=upload.enum.js.map